<template>
  <div class="predividas-page">

    <!-- ── SEÇÃO: Filtros ── -->
    <div class="form-section">
      <div class="form-section__header">
        <div class="form-section__icon-wrap">
          <v-icon color="#0052A0" size="20">mdi-filter-outline</v-icon>
        </div>
        <div>
          <div class="form-section__title">Filtros</div>
          <div class="form-section__sub">Refine os resultados por período, credor ou consumidor</div>
        </div>
      </div>

      <div class="form-section__body">
        <v-row dense>
          <v-col cols="12" md="2">
            <v-datetime-field
              only-date
              v-model="datainclusao"
              labelDate="Data Início"
              color="#0052A0"
              outlined dense
            ></v-datetime-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-datetime-field
              only-date
              v-model="datainclusaoFinal"
              labelDate="Data Fim"
              color="#0052A0"
              outlined dense
            ></v-datetime-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              outlined dense color="#0052A0"
              v-model="srcCredor"
              label="CPF/CNPJ Credor"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              outlined dense color="#0052A0"
              v-model="srcConsumidor"
              label="CPF/CNPJ Consumidor"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
              v-model="srcOrigem"
              :items="[{ name: 'MONITORA' }, { name: 'PGFN' }]"
              item-text="name"
              item-value="name"
              clearable
              outlined dense color="#0052A0"
              label="Origem da inclusão"
            ></v-select>
          </v-col>
        </v-row>

        <div class="filter-actions">
          <v-btn color="#0052A0" rounded elevation="0" @click="getPreDividas" class="px-5">
            <v-icon left color="#FFD400" small>mdi-magnify</v-icon>
            <span style="color:#FFD400;font-weight:700;font-size:13px">Buscar</span>
          </v-btn>
          <v-btn outlined rounded elevation="0" color="#0052A0" @click="limparFiltros" class="px-5">
            <v-icon left small>mdi-close-circle-outline</v-icon>
            <span style="font-size:13px">Limpar filtros</span>
          </v-btn>
        </div>
      </div>
    </div>

    <!-- ── SEÇÃO: Tabela ── -->
    <div class="form-section form-section--last">
      <v-data-table
        dense
        :headers="[
          { text: 'Ações', sortable: false, width: '60px' },
          { text: 'Data' },
          { text: 'Origem' },
          { text: 'Status', width: '140px' },
          { text: 'Usuário', width: '220px' },
          { text: 'N. Doc.' },
          { text: 'Dt. Emissão' },
          { text: 'Dt. Vencimento' },
          { text: 'Valor' },
          { text: 'CNPJ Credor', width: '160px' },
          { text: 'Credor Cadastrado', align: 'center' },
        ]"
        :items="list"
        item-key="lote"
        :single-expand="true"
        :search="search"
        show-expand
        class="predividas-table elevation-0"
        no-data-text="Sem dados"
        :footer-props="{
          'items-per-page-text': 'Linhas por página: ',
          'page-text': '{0}-{1} de {2}',
          'items-per-page-all-text': 'Listar todos',
        }"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn elevation="0" small icon v-bind="attrs" v-on="on" @click="modalAnalizar(item)">
                    <v-icon color="#0052A0" small>mdi-text-box-check-outline</v-icon>
                  </v-btn>
                </template>
                <span>Exibir Detalhes</span>
              </v-tooltip>
            </td>
            <td>{{ item.datacriacao }}</td>
            <td>{{ item.origem }}</td>
            <td>
              <v-chip small outlined :color="item.integrado == 1 ? 'success' : 'grey'" class="status-chip">
                {{ item.integrado == 0 ? "Não Integrado" : "Integrado" }}
              </v-chip>
            </td>
            <td>{{ item.user_id + " — " + item.userDetails.name }}</td>
            <td>{{ item.numero_titulo }}</td>
            <td>{{ converterDataTimestamp(item.data_emissao) }}</td>
            <td>{{ converterDataTimestamp(item.data_vencimento) }}</td>
            <td>{{ converterDinherio(item.valor_vencido) }}</td>
            <td>{{ formatarCpfCnpj(item.cnpj_credor) }}</td>
            <td class="text-center">
              <v-chip small :color="item.empresa_negativa ? '#22c55e' : '#94a3b8'" dark class="status-chip">
                {{ item.empresa_negativa ? "Sim" : "Não" }}
              </v-chip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <!-- ══ DIALOG: Rejeitar ══ -->
    <v-dialog v-model="dialogRejeitar" scrollable max-width="600">
      <v-card>
        <div class="dialog-header">
          <div class="dialog-header__icon-wrap">
            <v-icon color="#0052A0">mdi-close-octagon-outline</v-icon>
          </div>
          <div>
            <div class="dialog-header__title">Rejeitar Dívida</div>
            <div class="dialog-header__sub">Motivo da rejeição</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogRejeitar = false"><v-icon color="#64748b">mdi-close</v-icon></v-btn>
        </div>
        <v-card-text class="pa-6">
          <v-text-field
            label="Motivo"
            outlined readonly dense color="#0052A0"
            :value="prenchido(item.motivoRejeicao)"
          ></v-text-field>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- ══ DIALOG: Informações da Pré-Dívida ══ -->
    <v-dialog v-model="dialog" scrollable max-width="900">
      <v-card>
        <div class="dialog-header">
          <div class="dialog-header__icon-wrap">
            <v-icon color="#0052A0">mdi-file-document-outline</v-icon>
          </div>
          <div>
            <div class="dialog-header__title">Informação da Pré-Dívida</div>
            <div class="dialog-header__sub">Dados do consumidor, dívida e credor</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false"><v-icon color="#64748b">mdi-close</v-icon></v-btn>
        </div>

        <v-card-text class="pa-6" style="max-height:560px">

          <!-- Dados do consumidor -->
          <div class="dialog-section-label">
            <v-icon small color="#0052A0" class="mr-1">mdi-account-outline</v-icon>
            Dados do Consumidor
          </div>
          <v-row dense>
            <v-col cols="12" md="8">
              <v-text-field label="Nome" outlined readonly dense color="#0052A0"
                :value="prenchido(item.userDetails.name)"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field label="CPF/CNPJ" outlined readonly dense color="#0052A0"
                :value="formatarCpfCnpj(prenchido(item.userDetails.cpf_cnpj))"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="E-mail" outlined readonly dense color="#0052A0"
                :value="prenchido(item.userDetails.email)"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="Telefone Principal" outlined readonly dense color="#0052A0"
                :value="prenchido(item.userDetails.telefone)"></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field label="Endereço" outlined readonly dense color="#0052A0"
                :value="prenchido(item.endereco.endereco)"></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field label="Número" outlined readonly dense color="#0052A0"
                :value="prenchido(item.endereco.numero)"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field label="Bairro" outlined readonly dense color="#0052A0"
                :value="prenchido(item.endereco.bairro)"></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field label="CEP" outlined readonly dense color="#0052A0"
                :value="prenchido(item.endereco.cep)"></v-text-field>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field label="Município" outlined readonly dense color="#0052A0"
                :value="prenchido(item.endereco.municipio)"></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field label="UF" outlined readonly dense color="#0052A0"
                :value="prenchido(item.endereco.uf)"></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <!-- Dados da Dívida -->
          <div class="dialog-section-label">
            <v-icon small color="#0052A0" class="mr-1">mdi-currency-usd</v-icon>
            Dados da Dívida
          </div>
          <v-row dense>
            <v-col cols="12" md="3">
              <v-text-field label="Número do Documento" outlined readonly dense color="#0052A0"
                :value="prenchido(item.numero_titulo)"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field label="Nosso número" outlined readonly dense color="#0052A0"
                :value="prenchido(item.nosso_numero)"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field label="Espécie" outlined readonly dense color="#0052A0"
                :value="prenchido(item.especie)"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field label="Valor Original" outlined readonly dense color="#0052A0"
                :value="prenchido(converterDinherio(item.valor_original))"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field label="Valor Vencido" outlined readonly dense color="#0052A0"
                :value="prenchido(converterDinherio(item.valor_vencido))"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field label="Data Emissão" outlined readonly dense color="#0052A0"
                :value="prenchido(converterDataTimestamp(item.data_emissao))"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field label="Data Vencimento" outlined readonly dense color="#0052A0"
                :value="prenchido(converterDataTimestamp(item.data_vencimento))"></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <!-- Dados do Credor (ativo no sistema) -->
          <div v-if="item.empresa_negativa">
            <div class="dialog-section-label">
              <v-icon small color="#22c55e" class="mr-1">mdi-domain</v-icon>
              Credor Cadastrado no Sistema
            </div>
            <v-row dense>
              <v-col cols="12" md="3">
                <v-text-field label="CNPJ/CPF" outlined readonly dense color="#0052A0"
                  :value="prenchido(formatarCpfCnpj(item.cnpj_credor))"></v-text-field>
              </v-col>
              <v-col cols="12" md="9">
                <v-text-field label="Razão Social" outlined readonly dense color="#0052A0"
                  :value="prenchido(item.credor.name)"></v-text-field>
              </v-col>
              <v-col cols="12" md="7">
                <v-text-field label="Endereço" outlined readonly dense color="#0052A0"
                  :value="prenchido(item.credor.endereco_sub.endereco)"></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field label="Número" outlined readonly dense color="#0052A0"
                  :value="prenchido(item.credor.endereco_sub.numero)"></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field label="Bairro" outlined readonly dense color="#0052A0"
                  :value="prenchido(item.credor.endereco_sub.bairro)"></v-text-field>
              </v-col>
            </v-row>
          </div>

          <!-- Dados do Credor (não utiliza o sistema) -->
          <div v-if="!item.empresa_negativa">
            <div class="dialog-section-label">
              <v-icon small color="#f59e0b" class="mr-1">mdi-domain-off</v-icon>
              Credor não cadastrado no Sistema
            </div>
            <v-row dense>
              <v-col cols="12" md="3">
                <v-text-field label="CNPJ/CPF" outlined readonly dense color="#0052A0"
                  :value="prenchido(formatarCpfCnpj(item.cnpj_credor))"></v-text-field>
              </v-col>
              <v-col cols="12" md="9">
                <v-text-field label="Razão Social" outlined readonly dense color="#0052A0"
                  :value="prenchido(empresa_s_cadastro.nome)"></v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field label="Fantasia" outlined readonly dense color="#0052A0"
                  :value="prenchido(empresa_s_cadastro.fantasia)"></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field label="Situação" outlined readonly dense color="#0052A0"
                  :value="prenchido(empresa_s_cadastro.situacao)"></v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field label="Natureza Jurídica" outlined readonly dense color="#0052A0"
                  :value="prenchido(empresa_s_cadastro.natureza_juridica)"></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field label="Tipo" outlined readonly dense color="#0052A0"
                  :value="prenchido(empresa_s_cadastro.tipo)"></v-text-field>
              </v-col>
              <v-col cols="12" md="7">
                <v-text-field label="Endereço" outlined readonly dense color="#0052A0"
                  :value="prenchido(empresa_s_cadastro.logradouro)"></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field label="Número" outlined readonly dense color="#0052A0"
                  :value="prenchido(empresa_s_cadastro.numero)"></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field label="Bairro" outlined readonly dense color="#0052A0"
                  :value="prenchido(empresa_s_cadastro.bairro)"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="E-mail" outlined readonly dense color="#0052A0"
                  :value="prenchido(empresa_s_cadastro.email)"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="Telefone" outlined readonly dense color="#0052A0"
                  :value="prenchido(empresa_s_cadastro.telefone)"></v-text-field>
              </v-col>
            </v-row>
          </div>

        </v-card-text>

        <v-card-actions style="border-top:1px solid #e2e8f0; padding:12px 20px;">
          <v-spacer></v-spacer>
          <v-btn text rounded color="grey darken-1" @click="dialog = false" class="mr-1">
            <v-icon left small>mdi-close</v-icon>Fechar
          </v-btn>
          <v-btn text rounded color="error" @click="dialogRejeitar = true" class="mr-1">
            <v-icon left small>mdi-close-octagon-outline</v-icon>Invalidar Registro
          </v-btn>
          <v-btn color="#0052A0" rounded elevation="0" :disabled="!item.empresa_negativa" @click="integrarDivida" class="px-6">
            <v-icon left color="#FFD400" small>mdi-link-variant</v-icon>
            <span style="color:#FFD400;font-weight:700;font-size:13px">Integrar Dívida</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import helper from "../../mixins/helper";

export default {
  components: {},
  mixins: [helper],
  data: () => ({
    dialog: false,
    dialogRejeitar: false,

    datainclusao: null,
    datainclusaoFinal: null,
    srcConsumidor: null,
    srcCredor: null,
    srcOrigem: null,
    empresa_s_cadastro: {
      nome: null,
      telefone: null,
    },
    credorsemcadastro: {},
    list: [],
    item: {
      userDetails: {
        name: null,
        fantasia: null,
        telefone: null,
        email: null,
        bairro: null,
        numero: null,
        cep: null,
        logradouro: null,
        tipo: null,
        situacao: null,
        natureza_juridica: null,
        atividade_principal: [{ text: null }],
      },
      endereco: {
        endereco: null,
        numero: null,
        bairro: null,
        cep: null,
        municipio: null,
        uf: null,
      },
    },
    search: "",
  }),
  mounted() {
    this.getPreDividas();
  },

  methods: {
    notificacao(title, msg, icon) {
      this.$swal({
        toast: true,
        position: "top-center",
        showConfirmButton: false,
        timer: 3000,
        icon: icon,
        title: title,
        text: msg,
      });
    },

    integrarDivida() {
      this.$http
        .post("preDivida/gerarDivida", {
          predivida_id: this.item.id,
          empresa_id: this.item.credor.id,
        })
        .then(
          (response) => {
            this.notificacao("Sucesso", response.data.message, "success");
          },
          (response) => {
            console.log(response);
          }
        );
    },

    async dadosEmpresaNCadastrada(cnpj) {
      this.$http.get(`buscarEmpresaReceita/${cnpj}`).then(
        (response) => {
          this.empresa_s_cadastro = response.data;
        },
        (response) => {
          console.log(response.data);
        }
      );
    },

    getPreDividas() {
      this.$http
        .get(
          `getPreDividas?srcOrigem=${this.srcOrigem}&&datainclusao=${this.datainclusao}&datainclusaoFinal=${this.datainclusaoFinal}&srcConsumidor=${this.srcConsumidor}&srcCredor=${this.srcCredor}`
        )
        .then(
          (response) => {
            this.list = response.data;
          },
          (response) => {
            console.log(response);
          }
        );
    },

    limparFiltros() {
      this.datainclusao = null;
      this.datainclusaoFinal = null;
      this.srcConsumidor = null;
      this.srcCredor = null;
      this.srcOrigem = null;
    },

    async modalAnalizar(item) {
      this.item = item;
      await this.dadosEmpresaNCadastrada(item.cnpj_credor);
      this.dialog = true;
    },

    prenchido(item) {
      return item === null ? "Não preenchido" : item;
    },
  },
};
</script>

<style scoped>
/* ─── Layout ─────────────────────────────────────────── */
.predividas-page {
  background: #fff;
  min-height: calc(100vh - 64px);
  padding: 28px 32px;
  width: 100%;
  box-sizing: border-box;
}

/* ─── Seções ─────────────────────────────────────────── */
.form-section {
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 32px;
  margin-bottom: 32px;
}
.form-section--last {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.form-section__header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 0 0 18px 0;
}
.form-section__icon-wrap {
  width: 34px; height: 34px;
  background: #e8f0fe;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}
.form-section__title {
  font-family: 'Inter', sans-serif;
  font-size: 0.92rem;
  font-weight: 700;
  color: #1e293b;
}
.form-section__sub {
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  color: #94a3b8;
  margin-top: 1px;
}
.form-section__body {
  padding: 0;
}

/* ─── Botões de filtro ───────────────────────────────── */
.filter-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 4px;
}
@media (max-width: 600px) {
  .filter-actions > .v-btn { flex: 1 1 auto; min-width: 0 !important; }
}

/* ─── Tabela ─────────────────────────────────────────── */
.predividas-table >>> th {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  color: #64748b !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: #f8fafc !important;
}
.predividas-table >>> td {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.85rem !important;
  color: #1e293b !important;
  font-weight: 400 !important;
}

/* ─── Status chip ────────────────────────────────────── */
.status-chip {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.72rem !important;
  font-weight: 600 !important;
}

/* ─── Inputs ─────────────────────────────────────────── */
.predividas-page >>> .v-input__slot {
  background-color: #fff !important;
  box-shadow: none !important;
}
.predividas-page >>> .v-label {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.85rem !important;
}
.predividas-page >>> input {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.88rem !important;
  color: #1e293b !important;
}

/* ─── Dialog ─────────────────────────────────────────── */
.dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
}
.dialog-header__icon-wrap {
  width: 36px; height: 36px;
  background: #e8f0fe;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.dialog-header__title {
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  color: #1e293b;
}
.dialog-header__sub {
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  color: #94a3b8;
  margin-top: 2px;
}

.dialog-section-label {
  display: flex;
  align-items: center;
  font-family: 'Inter', sans-serif;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #94a3b8;
  margin-bottom: 12px;
}

/* ─── Responsivo ─────────────────────────────────────── */
@media (max-width: 768px) {
  .predividas-page { padding: 16px; }
  .filter-actions { flex-wrap: wrap; }
}
</style>
